import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import { useMemo } from 'react'

function useNewrelic() {
    // Populate using values in copy-paste JavaScript snippet.
    const options = {
        init: {
            distributed_tracing: { enabled: true }, // This enables distributed tracing, which allows you to trace requests as they move through various components of a distributed application, helping you identify bottlenecks and performance issues.
            privacy: { cookies_enabled: true }, // This appears to set an option related to privacy. It enables the use of cookies for tracking or other purposes.
            ajax: { deny_list: ['bam.nr-data.net'] }, // This is configuring a deny list for AJAX requests. Requests to the domain 'bam.nr-data.net' are excluded or blocked, meaning New Relic won't monitor or collect data from this domain
            jserrors: { enabled: true }, // This enables monitoring of JavaScript errors. New Relic will capture and report errors that occur in your web application.
        }, // NREUM.init
        info: {
            accountID: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
            trustKey: process.env.REACT_APP_NEW_RELIC_TRUST_KEY,
            agentID: process.env.REACT_APP_NEW_RELIC_AGENT_ID,
            licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
            applicationID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
        }, // NREUM.info
        loader_config: {
            beacon: 'bam.nr-data.net',
            errorBeacon: 'bam.nr-data.net',
            licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
            applicationID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
            sa: 1, // Session tracing allows you to track and analyze user sessions to gain insights into their interactions with your web application.
        }, // NREUM.loader_config
    }

    // The agent loader code executes immediately on instantiation.
    const NrAgent = useMemo(() => {
        // create this instance only once
        const agent = new BrowserAgent({ ...options })
        return agent
    }, [options])
    return { NrAgent }
}

export default useNewrelic
